import { render, staticRenderFns } from "./disclose.vue?vue&type=template&id=6857a545&scoped=true&"
import script from "./disclose.vue?vue&type=script&lang=js&"
export * from "./disclose.vue?vue&type=script&lang=js&"
import style0 from "./disclose.vue?vue&type=style&index=0&lang=css&"
import style1 from "./disclose.vue?vue&type=style&index=1&id=6857a545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6857a545",
  null
  
)

export default component.exports